import HomeView from '@/views/HomeView/HomeView.vue'
import DefaultHeader from '@/views/DefaultHeader/DefaultHeader.vue'
import ErrorView from '@/views/ErrorView.vue'
import { loginRedirect } from '@/hooks/authentication'
import routeNames from '@/router/names'
import * as loaded from '@/hooks/loaded'
import * as failed from '@/hooks/failed'
import routeViews from '@/router/views'
import {
  FILTER_MINE,
  FILTER_ALL,
  FILTER_CERTIFIED,
  FILTER_TRASH,
} from '@/helpers/homeFilters'

export default [
  {
    path: '/',
    name: routeNames.Home,
    meta: {
      loaded: loaded.home,
      failed: failed.home,
      title: (route) => {
        switch (route.query.filter) {
          case FILTER_ALL:
            return 'generic.all' // TODO: Translate "All profiles"
          case FILTER_TRASH:
            return 'generic.trash'
          case FILTER_CERTIFIED:
            return 'generic.official' // TODO: Translate "Certified profiles"
          case FILTER_MINE:
            return 'generic.mine' // TODO: Translate "My profiles"
          default:
            return 'menu.profiles'
        }
      },
    },
    components: {
      [routeViews.Main]: HomeView,
      [routeViews.Header]: DefaultHeader,
    },
  },
  {
    // Route called by SSO
    path: '/redirect',
    name: routeNames.SSORedirect,
    meta: {
      bypassAuth: true,
      loaded: loaded.bypass,
      failed: failed.bypass,
      title: 'pb2.pageTitles.redirect',
    },
    component: { functional: true },
    beforeEnter: loginRedirect,
  },
  // -- 404 for * -  should be last
  {
    path: '/:pathMatch(.*)*',
    name: routeNames.Error,
    components: {
      [routeViews.Main]: ErrorView,
      [routeViews.Header]: DefaultHeader,
    },
    meta: {
      title: 'pb2.pageTitles.error',
      loaded: loaded.bypass,
      failed: failed.bypass,
      bypassAuth: true,
    },
  },
]
